import React from 'react';
import { IconProps } from '../../types/types';

const SynconIcon: React.FC<IconProps> = ({ size = '17', color = '#292D32' }) => (
    <svg width={size} height={size} viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.1667 8.50001C15.1667 12.18 12.18 15.1667 8.50004 15.1667C4.82004 15.1667 2.57337 11.46 2.57337 11.46M2.57337 11.46H5.58671M2.57337 11.46V14.7933M1.83337 8.50001C1.83337 4.82001 4.79337 1.83334 8.50004 1.83334C12.9467 1.83334 15.1667 5.54001 15.1667 5.54001M15.1667 5.54001V2.20668M15.1667 5.54001H12.2067" stroke={color} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>

);

export default SynconIcon;